import script from "./contedo-menu-admin.vue?vue&type=script&setup=true&lang=js"
export * from "./contedo-menu-admin.vue?vue&type=script&setup=true&lang=js"

import "./contedo-menu-admin.vue?vue&type=style&index=0&id=2bd5e470&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2bd5e470"]])

export default __exports__